import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/Images2.css';
import View2 from './image/View2';
import PageModal from '../modals/PageModal';
import EmptyView from '../EmptyView';
import Loader from '../Loader';
import LeftNav from '../LeftNav';
import { authorizedHttpGet } from '../../api/httpCalls';
import urls from '../../api/urls.json';

const AutoUpdatesImages = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [appName, setAppName] = useState(localStorage.getItem('appName'));
    const [page, setPage] = useState(1);
    const [profileState, setProfileState] = useState('approved');
    const [profiles, setProfiles] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const totalProfiles = useRef(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showPageModal, setShowPageModal] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem('authToken') || !localStorage.getItem('verificationPassed')) {
            sessionStorage.setItem('redirectUrl', location.pathname);
            navigate('/login');
        }
    }, [location.pathname, navigate]);

    const fetchProfiles = useCallback(async () => {
        setIsLoading(true);
        const response = await authorizedHttpGet(urls.GET_AUTO_UPDATES_IMAGES, { page, profile_state: profileState });
        if (response.status) {
            setProfiles(response.data.profiles || []);
            setTotalPages(response.data.total_pages || 0);
            totalProfiles.current = response.data.total_profiles || 0;
        }
        setIsLoading(false);
    }, [page, profileState]);

    useEffect(() => { fetchProfiles(); }, [fetchProfiles, appName]);

    const handleAppChange = (name) => {
        setAppName(name);
        setPage(1);
    };

    const profileStateOptions = [
        { value: 'approved', label: 'Approved' },
        { value: 'disapproved', label: 'Disapproved' },
    ];

    const goToPage = (nextPage) => {
        setShowPageModal(false);
        if (nextPage < 1 || nextPage > totalPages) {
            alert('Page number is greater than total pages');
            return;
        }
        setPage(nextPage);
    };

    return (
        <div className="App imagesMainDiv">
            {showPageModal && <PageModal closeModal={() => setShowPageModal(false)} page={page} goToPage={goToPage} />}
            {isLoading && <Loader isLoading={isLoading} />}
            <LeftNav handleLeftNavAppChange={handleAppChange} tabName="Auto Updates" />
            <div className="mainDiv">
                <div className="headerText">
                    <div className="pageNumber" onClick={() => setShowPageModal(true)}>
                        <span className="selectedSpan">{page}</span>
                        <span className="unSelectedSpan">{totalPages}</span>
                        <span className="unSelectedSpan">{totalProfiles.current}</span>
                    </div>
                    <div className="autoUpdatesFilters" role="tablist" aria-label="Filter auto updates by profile status">
                        {profileStateOptions.map((option) => (
                            <button
                                type="button"
                                key={option.value}
                                className={profileState === option.value ? 'active' : ''}
                                onClick={() => {
                                    if (profileState === option.value) return;
                                    setProfileState(option.value);
                                    setPage(1);
                                }}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                </div>
                {profiles.length > 0 ? (
                    <View2
                        profiles={profiles}
                        page={page}
                        cancelReview={() => {}}
                        afterSave={fetchProfiles}
                        postUrl={urls.POST_AUTO_UPDATES_IMAGES}
                        sourceTab="auto_updates_images"
                        showStatusTag
                        likeLabel="Accept"
                        passLabel="Reject"
                    />
                ) : <EmptyView />}
            </div>
        </div>
    );
};

export default AutoUpdatesImages;
